import { Avatar, Flex, Text, Divider } from "@chakra-ui/react";

export const Profile = () => {
  const user = JSON.parse(localStorage.getItem("profile"));
  return (
    <>
      <Flex alignItems="center" p={4}>
        <Avatar src={user.profileUrl} />
        <Flex direction="column">
          <Text as="b" pl={3}>
            {user.name}
          </Text>
          <Text as="i" pl={3}>
            {user.email}
          </Text>
        </Flex>
      </Flex>
      <Divider orientation="horizontal" />
    </>
  );
};
